import React, { memo, useState, useEffect } from "react";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import { get, map, throttle } from "lodash";
import produce from "immer";
import Fuse from "fuse.js";
import {
  Input,
  InputAdornment,
  MenuList,
  MenuItem,
  Paper,
  Typography,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  FormControl,
  InputLabel,
  Box
} from "@material-ui/core";
import { Search as SearchIcon, Delete as DeleteIcon } from "@material-ui/icons";
import { createSubscription } from "../../../../utils/db";
import { renderValues, collectionToArray } from "../../../../utils/functions";
import { makeStyles } from "@material-ui/styles";

let fuse;
const useStyles = makeStyles({
  root: {
    position: "relative"
  },
  menu: {
    maxHeight: 150,
    overflow: "auto"
  },
  searchResultsContainer: {
    position: "absolute",
    top: "3rem",
    width: "100%",
    zIndex: 30
  }
});

const Search = ({ label, value, onChange, relation, data, multiple }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const classes = useStyles();

  fuse = new Fuse(collectionToArray(data), {
    keys: relation.fields || [],
    shouldSort: true,
    threshold: 0.1,
    location: 0,
    distance: 3,
    maxPatternLength: 32,
    minMatchCharLength: 1
  });

  const search = throttle(e => {
    setSearchResults(fuse.search(e.target.value));
    if (!showSearchResults) {
      setShowSearchResults(true);
    }
  }, 300);

  const addItem = itemId => e => {
    const items = produce(value || [], draftState => {
      draftState.push(itemId);
    });

    setShowSearchResults(false);
    onChange(items);
  };

  const removeItem = index => e => {
    const items = produce(value, draftState => {
      draftState.splice(index, 1);
    });

    onChange(items);
  };

  useEffect(() => {}, [value, data]);

  useEffect(() => {
    fuse = new Fuse(collectionToArray(data), {
      keys: relation.fields || [],
      shouldSort: true,
      threshold: 0.1,
      location: 0,
      distance: 3,
      maxPatternLength: 32,
      minMatchCharLength: 1
    });
  }, [data]);

  createSubscription(relation.ref);

  return (
    <div className={classes.root}>
      {(multiple || !value || !value.length) && (
        <Box mb={1}>
          <FormControl fullWidth>
            <InputLabel>{label}</InputLabel>
            <Input
              margin="none"
              label={label}
              onClick={() => setShowSearchResults(true)}
              fullWidth
              type="search"
              placeholder="Search"
              endAdornment={
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              }
              onChange={search}
            />
          </FormControl>
        </Box>
      )}

      {value && value.length ? (
        <Paper>
          {map(value, (item, index) => (
            <ListItem key={`${item}_${index}`}>
              <ListItemText>
                <Typography variant="inherit" noWrap>
                  {map(relation.fields, field =>
                    renderValues({ value: get(data, [item, field]) })
                  ).join(" / ")}
                </Typography>
                <ListItemSecondaryAction>
                  <IconButton onClick={removeItem(index)}>
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItemText>
            </ListItem>
          ))}
        </Paper>
      ) : null}

      {searchResults.length && showSearchResults ? (
        <Paper className={classes.searchResultsContainer}>
          <MenuList className={classes.menu}>
            {map(searchResults, result => (
              <MenuItem key={result.id} onClick={addItem(result.id)}>
                <Typography variant="inherit" noWrap>
                  {map(relation.fields, field =>
                    renderValues({ value: result[field] })
                  ).join(" / ")}
                </Typography>
              </MenuItem>
            ))}
          </MenuList>
        </Paper>
      ) : null}
    </div>
  );
};

export default hot(module)(
  memo(
    connect(
      ({ dbState }, props) => ({ data: get(dbState, `${props.relation.ref}`) }),
      null
    )(Search),
    (pp, np) => false
  )
);
